// Material Kit 2 React pages
import Semesters from "pages/ElearningAndQuestionPapers/Semseters";

export default function SemesterPage() {
  return <Semesters />;
}
